import { Node, mergeAttributes, type CommandProps } from '@tiptap/core';
import { resolveEmbedUrl } from '../utils/embed-validator';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    videoEmbed: {
      insertVideoEmbed: (url: string) => ReturnType;
    };
  }
}

export const VideoEmbed = Node.create({
  name: 'videoEmbed',
  group: 'block',
  atom: true,

  addAttributes() {
    return {
      src: { default: null },
      provider: { default: null },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-video-embed]' }];
  },

  renderHTML({ HTMLAttributes }) {
    const { src, provider, ...rest } = HTMLAttributes as {
      src: string;
      provider: string;
      [key: string]: unknown;
    };
    return [
      'div',
      mergeAttributes(rest, {
        'data-video-embed': '',
        'data-testid': 'rich-text-video-embed',
        class: 'rich-text-video-embed',
      }),
      [
        'iframe',
        {
          src,
          frameborder: '0',
          allowfullscreen: '',
          sandbox: 'allow-scripts allow-same-origin',
          'data-provider': provider,
          class: 'rich-text-video-iframe',
        },
      ],
    ];
  },

  addCommands() {
    return {
      insertVideoEmbed:
        (url: string) =>
        ({ commands }: CommandProps) => {
          const result = resolveEmbedUrl(url);
          if (!result) return false;
          return commands.insertContent({
            type: this.name,
            attrs: { src: result.embedUrl, provider: result.provider },
          });
        },
    };
  },
});

export function buildVideoEmbedExtension() {
  return VideoEmbed;
}
